module.exports = __webpack_public_path__ + "img/partner-3.f4296a43.png";